export const THDFormHelperTextStyles = {
    root: {
        fontSize: '12px',
        fontFamily: '"helvetica-neue", Helvetica Neue, Helvetica, Arial, sans-serif',
        '&$error': {
            color: '#AB0000',
        },
    },
    error: {},
    disabled: {},
    marginDense: {},
    focused: {},
    filled: {},
    required: {},
};
